import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class SkillDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  logInModal: boolean = false;
  showModal: boolean = false;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  skill_id: any = [];
  name: string = "";
  value: string = "";
  percentage: string = "";
  createdAt: string = "";
  updatedAt: string = "";


  mounted (){
    const _ = this;
    _.getBySkill();
    _.filterDate();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getBySkill(){
    const _ = this;
    _.skill_id = location.href.split("/");
    _.skill_id = _.skill_id[5];
    _.isLoading = true;
    _.detailService.getBySkill(_.skill_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].skill.name;
      _.createdAt = data["data"].skill.createdAt;
      _.updatedAt = data["data"].skill.updatedAt;
      _.value = data["data"].skill.scores[0].value;
      _.percentage = data["data"].skill.scores[0].percentage;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
